import socketIOClient from "socket.io-client";

import api from "../../../api";
import { APIResponse } from "../../../types/APIResponseType";
import { BrandgenListDomain, BrandgenPublicationList } from "../../../types/campaignTypes";

export const getPublicDomainLists = async () => {
  try {
    const { payload } = await api.getPublicPublicationLists();
    return payload;
  } catch (error) {
    throw new Error((error as Error)?.message ?? String(error));
  }
};

export const getCustomDomainLists = async (brandgenAdvertiserId: string) => {
  try {
    const { payload } = await api.getDomainLists(brandgenAdvertiserId);
    return payload;
  } catch (error) {
    throw new Error((error as Error)?.message ?? String(error));
  }
};

export const createDomainList = (
  bgAdvertiserId: string,
  adLibAdvertiserId: number,
  name: string,
  domains: string[],
  saveCreatedDomainList: (createdDomainList: BrandgenPublicationList) => void,
) => {
  const socket = socketIOClient(process.env.REACT_APP_BACKEND_URL!);
  socket.emit("createNewDomainList", {
    bgAdvertiserId,
    adLibAdvertiserId,
    listName: name,
    domains,
  });

  socket.on("newPublicationListCreated", (response: APIResponse) => {
    saveCreatedDomainList(response.payload as BrandgenPublicationList);
    socket.close();
  });

  socket.on("publicationListRuleGroupCreationError", (err: unknown) => {
    socket.close();
    throw new Error(err instanceof Error ? err.message : String(err));
  });
};

export const updateDomainList = (
  listId: string,
  listName: string,
  domainsToUpdate: BrandgenListDomain[],
  domainsToAdd: string[],
  saveUpdatedDomainListToStore: (updatedDomainLists: BrandgenPublicationList[]) => void,
) => {
  const socket = socketIOClient(process.env.REACT_APP_BACKEND_URL!);
  socket.emit("updateDomainList", {
    listId,
    listName,
    domainsToUpdate,
    domainsToAdd,
  });

  socket.on("domainListUpdated", (response: APIResponse) => {
    saveUpdatedDomainListToStore(response.payload as BrandgenPublicationList[]);
    socket.close();
  });

  socket.on("domainListUpdateError", (err: unknown) => {
    socket.close();
    throw new Error(err instanceof Error ? err.message : String(err));
  });
};
